module.exports = __webpack_public_path__ + "165cd3fad2407f87e9b1f07ce3b2b092.png";